import {Component, OnInit, ViewChild} from '@angular/core';
import {DataTableDirective} from "angular-datatables";
import {BannerService} from "../../services/banner.service";
import {first} from "rxjs/operators";
declare var swal: any;

@Component({
    selector: 'app-banners',
    templateUrl: './banners.component.html',
    styleUrls: ['./banners.component.scss']
})
export class BannersComponent implements OnInit {
    dtOptions: DataTables.Settings = {};
    banners: any = [];

    @ViewChild(DataTableDirective) private dtElement;
    constructor(
        private bannerService: BannerService,
    ) { }

    ngOnInit(): void {
        this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 10,
            serverSide: true,
            processing: true,
            ajax: (dataTablesParameters: any, callback) => {
                this.bannerService.getDatatable(dataTablesParameters)
                    .pipe(first())
                    .subscribe(response => {
                        this.banners = response.data;
                        callback({
                            recordsTotal: response.recordsTotal,
                            recordsFiltered: response.recordsFiltered,
                            data: []
                        })
                    })
            },
            columns: [
                {data: 'main_image'},
                {data: 'mobile_image'},
                {data: 'main_text'},
                {data: 'secondary_image'},
                {data: 'button_text'},
                {data: 'link_text'},
                {data: 'status'},
            ]
        }
    }

    private async reloadTable() {
        let dtIntance = await this.dtElement.dtInstance;
        dtIntance.ajax.reload();
    }

    delete(item: any): void{
        swal.fire({
            title: '¿Estás seguro que deseas eliminar este registro?',
            showCancelButton: true,
            confirmButtonText: 'Si, elimínalo!',
            showLoaderOnConfirm: true,
            preConfirm: (arg) => {
                return this.bannerService.delete(item.id)
                    .pipe(first())
                    .subscribe(response => {
                        swal.fire({
                            title: 'Elemento eliminado con éxito',
                            type: 'success'
                        });
                        this.reloadTable();
                    },error => {
                        swal.fire({
                            title: error,
                            type: 'error'
                        });
                        return error;
                    });
            },
            allowOutsideClick: () => !swal.isLoading()
        }).then((result) => {
        });
    }
}
